import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRight = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.84353 15.6739C6.60685 15.4461 6.60685 15.0767 6.84353 14.8489L11.8695 10.0114L6.84353 5.17387C6.60684 4.94607 6.60684 4.57672 6.84353 4.34892C7.08021 4.12111 7.46394 4.12111 7.70063 4.34892L13.1552 9.59891C13.3919 9.82672 13.3919 10.1961 13.1552 10.4239L7.70063 15.6739C7.46394 15.9017 7.08021 15.9017 6.84353 15.6739Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgChevronRight);
export default ForwardRef;
